import { useState, useEffect } from 'react';

/**
 * Bandeau fixe qui apparait quand le Service Worker detecte une nouvelle version.
 * Cliquer dessus recharge la page pour charger les nouveaux assets.
 */
export default function UpdateBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = () => setShowBanner(true);
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  if (!showBanner) return null;

  const handleClick = () => {
    window.location.reload();
  };

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      className="fixed top-0 left-0 right-0 z-[200] bg-blue-600 text-white text-center py-2 text-sm font-medium cursor-pointer hover:bg-blue-700"
    >
      Mise à jour disponible — Cliquer pour actualiser
    </div>
  );
}
